import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Toaster } from 'sonner';

import { AuthProvider } from '@/core/providers/auth/auth-provider';
import { AuthBootstrap } from '@/core/providers/auth/auth-bootstrap';

import '@/core/theme/global.css';

import { RouterManager } from '@/router-manager';
import { BrowserRouter } from 'react-router-dom';

import { GlobalErrorBoundary } from '@/core/providers/global-error-boundary';
import { HttpInterceptorProvider } from '@/core/providers/http/http-interceptor-provider';
import { InactivityProvider } from '@/core/providers/inactivity-provider';

import { AppQueryProvider } from './core/providers/query-provider';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Toaster richColors position="top-right" />
    <GlobalErrorBoundary>
      {/* Enables navigation and the routing system */}
      <BrowserRouter>
        {/* Authentication and user session management */}
        <AuthProvider>
          <AuthBootstrap>
            <AppQueryProvider>
              <HttpInterceptorProvider>
                <InactivityProvider>
                  <RouterManager />
                </InactivityProvider>
              </HttpInterceptorProvider>
            </AppQueryProvider>
          </AuthBootstrap>
        </AuthProvider>
      </BrowserRouter>
    </GlobalErrorBoundary>
  </StrictMode>,
);
